import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.object.values";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.split";
import workerStatsByArg from "./common/workerStatsByArg";
import rollbackWorkerDays from "./common/rollbackWorkerDays";
import workerDaysByArg from "./common/workerDaysByArg";
import { deepClone } from '@/modules/mm-utils';
import dayjs from 'dayjs';
var lastTableView;

var formatToSeconds = function formatToSeconds(time) {
  var seconds = 900; // 15 minutes

  if (time) {
    var arr = time.split(':');
    seconds = arr[0] * 60 + arr[1] * 60 + Number(arr[2]);
  }

  return seconds;
};

export default (function (_ref, _ref2) {
  var commit = _ref.commit,
      rootState = _ref.rootState,
      state = _ref.state;
  var tableView = _ref2.tableView;
  if (tableView) lastTableView = tableView;
  if (!tableView) tableView = lastTableView;

  if (tableView) {
    rollbackWorkerDays.purge();
    var resArgs;

    switch (tableView) {
      case 'planApproved':
        resArgs = ['PLAN_APPR'];
        break;

      case 'planUnapproved':
        resArgs = ['PLAN_UNAPPR'];
        break;

      case 'factApproved':
        resArgs = ['FACT_APPR'];
        break;

      case 'factUnapproved':
        resArgs = ['FACT_UNAPPR'];
        break;

      case 'planBothCompare':
        resArgs = ['PLAN_UNAPPR', 'PLAN_APPR'];
        break;

      case 'planFactApprovedCompare':
        resArgs = ['PLAN_APPR', 'FACT_APPR'];
        break;

      case 'factBothCompare':
        resArgs = ['FACT_UNAPPR', 'FACT_APPR'];
        break;

      case 'factTabel':
        resArgs = ['FACT_TABEL'];
        break;
    }

    commit('setTableCellParts', resArgs);

    if (workerDaysByArg.hasValues()) {
      var workerDays = resArgs.map(function (resArg) {
        return workerDaysByArg.get(resArg);
      });
      commit('setWorkerDays', workerDays);
      var bottomCorners = {};

      if (['planBothCompare', 'factBothCompare'].includes(tableView)) {
        var draft = workerDays[0] || {};
        var approved = workerDays[1] || {};
        var allKeys = Object.keys(draft);
        Object.keys(approved).forEach(function (key) {
          if (!allKeys.includes(key)) {
            allKeys.push(key);
          }
        });
        allKeys.forEach(function (key) {
          if (!approved[key] || !draft[key]) {
            bottomCorners[key] = {
              text: ['unapprovedChanges'],
              color: 'different'
            };
            return;
          }

          var draftCount = draft[key].shifts.length;
          var apprCount = approved[key].shifts.length;

          if (draftCount !== apprCount) {
            bottomCorners[key] = {
              text: ['unapprovedChanges'],
              color: 'different'
            };
            return;
          }

          draft[key].shifts.forEach(function (unapprDay) {
            var hasSimilar = approved[key].shifts.some(function (apprDay) {
              return apprDay.type === unapprDay.type && apprDay.dttm_work_start === unapprDay.dttm_work_start && apprDay.dttm_work_end === unapprDay.dttm_work_end && apprDay.shop_id === unapprDay.shop_id && apprDay.work_type_id === unapprDay.work_type_id && apprDay.is_vacancy === unapprDay.is_vacancy && apprDay.work_hours === unapprDay.work_hours;
            });

            if (hasSimilar) {
              return;
            }

            bottomCorners[key] = {
              text: ['unapprovedChanges'],
              color: 'different'
            };
          });
        });
      } else if (tableView === 'planFactApprovedCompare') {
        var _rootState$user, _rootState$user$data;

        var userNetwork = ((_rootState$user = rootState.user) === null || _rootState$user === void 0 ? void 0 : (_rootState$user$data = _rootState$user.data) === null || _rootState$user$data === void 0 ? void 0 : _rootState$user$data.network) || {};
        var arrivalInterval = formatToSeconds(userNetwork.allowed_interval_for_late_arrival);
        var departureInterval = formatToSeconds(userNetwork.allowed_interval_for_early_departure);
        var unaccountedOvertimeThreshold = userNetwork.unaccounted_overtime_threshold;
        var plan = workerDays[0] || {};
        var fact = workerDays[1] || {};
        var planDays = [];
        var factDays = [];
        var typesOfCorners = [{
          text: ['tardinessAndEarlyLeave'],
          color: 'negative'
        }, {
          text: ['allowedInterval'],
          color: 'warning'
        }, {
          text: ['allowedInterval'],
          color: 'warning'
        }, false, {
          text: [],
          color: 'positive'
        }, {
          text: ['inconsistencyOfShops'],
          color: 'negative'
        }, {
          text: ['inconsistencyOfWorkType'],
          color: 'negative'
        }, {
          text: ['inconsistencyOfDayType'],
          color: 'negative'
        }];
        Object.values(plan).forEach(function (el) {
          el.shifts.forEach(function (i) {
            if (state.workDayTypes.includes(i.type)) {
              planDays.push(i);
            }
          });
        });
        Object.values(fact).forEach(function (el) {
          el.shifts.forEach(function (i) {
            if (state.workDayTypes.includes(i.type)) {
              factDays.push(i);
            }
          });
        });
        planDays.forEach(function (pDay) {
          var cellId = "".concat(pDay.dt, "_").concat(pDay.employee_id);
          var foundDay = factDays.find(function (fDay) {
            return fDay.closest_plan_approved_id === pDay.id;
          });
          var cornerData = {
            text: ['noData'],
            color: 'negative'
          };

          if (foundDay) {
            var pDayStart = dayjs(pDay.dttm_work_start);
            var fDayStart = dayjs(foundDay.dttm_work_start);
            var pDayEnd = dayjs(pDay.dttm_work_end);
            var fDayEnd = dayjs(foundDay.dttm_work_end);
            var isShopDiff = pDay.shop_id !== foundDay.shop_id;
            var isWorkTypeDiff = pDay.work_type_id !== foundDay.work_type_id;
            var isDayTypeDiff = pDay.type !== foundDay.type;
            var diffStart = pDayStart.diff(fDayStart, 'seconds');
            var diffEnd = fDayEnd.diff(pDayEnd, 'seconds');
            var startStatus = 0; // negative

            var endStatus = 0; // negative

            if (diffStart >= 0) {
              startStatus = 2; // positive
            }

            if (diffStart < 0 && Math.abs(diffStart) <= arrivalInterval) {
              startStatus = 1; // warning
            }

            if (diffEnd >= 0) {
              endStatus = 2; // positive
            }

            if (diffEnd < 0 && Math.abs(diffEnd) <= departureInterval) {
              endStatus = 1; // warning
            }

            var statusMult = startStatus * endStatus;

            if (isShopDiff) {
              statusMult = 5; // inconsistency of shops
            }

            if (isWorkTypeDiff) {
              statusMult = 6; // inconsistency of work types
            }

            if (isDayTypeDiff) {
              statusMult = 7; // inconsistency of work types

              startStatus = 0;
              endStatus = 0;
            }

            cornerData = deepClone(typesOfCorners[statusMult]);
            cornerData.start = startStatus;
            cornerData.end = endStatus;

            if (pDay.is_vacancy !== foundDay.is_vacancy && rootState.user.data.network.allow_to_manually_set_is_vacancy) {
              var _cornerData, _cornerData$text;

              // main/additional attribute (is_vacancy) don't match
              cornerData.color = 'negative';

              if ((_cornerData = cornerData) !== null && _cornerData !== void 0 && (_cornerData$text = _cornerData.text) !== null && _cornerData$text !== void 0 && _cornerData$text.push) {
                cornerData.text.push('additionalShiftMismatch');
              }
            }
          }

          if (bottomCorners[cellId]) {
            var _cornerData2;

            if (cornerData.color === 'negative') {
              bottomCorners[cellId].color = 'negative';
            }

            if ((_cornerData2 = cornerData) !== null && _cornerData2 !== void 0 && _cornerData2.text.length) {
              cornerData.text.forEach(function (item) {
                if (!bottomCorners[cellId].text.includes(item)) {
                  bottomCorners[cellId].text.push(item);
                }
              });
            }
          } else {
            bottomCorners[cellId] = cornerData;
          }

          if (foundDay !== null && foundDay !== void 0 && foundDay.closest_plan_approved_id) {
            cellId += "_".concat(foundDay.closest_plan_approved_id);
            bottomCorners[cellId] = cornerData;
          }
        });
        factDays.forEach(function (fDay) {
          var cellId = "".concat(fDay.dt, "_").concat(fDay.employee_id);
          var corner = bottomCorners[cellId];

          if (!fDay.closest_plan_approved_id) {
            if (corner && corner.color === 'negative') {
              if (!corner.text.includes('unplannedAttendance')) {
                corner.text.push('unplannedAttendance');
              }
            } else {
              bottomCorners[cellId] = {
                text: ['unplannedAttendance'],
                color: 'negative'
              };
            }
          }

          if (fDay.unaccounted_overtime > unaccountedOvertimeThreshold) {
            if (!corner) {
              bottomCorners[cellId] = {
                text: ['unaccountedOvertime'],
                color: 'warning'
              };
            } else if (corner.color !== 'negative' && !corner.text.includes('unaccountedOvertime')) {
              corner.text.push('unaccountedOvertime');
              corner.color = 'warning';
            }
          }
        });
      }

      commit('setBottomCorners', bottomCorners);
    } else {
      commit('setWorkerDays', []);
    }

    var statsArgs = _toConsumableArray(resArgs);

    var workerStats = statsArgs.map(function (statsArg) {
      return workerStatsByArg.get(statsArg);
    });
    commit('setWorkerStats', workerStats);
  }
});